import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { SpinnerModule } from 'primeng/spinner';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { SharedModule } from '../../shared/shared.module';
import { CustomerIdentificationModule } from '../identification/customer-identification.module';
import { CustomerNamesModule } from '../name/customer-names.module';
import { CustomerPipeModule } from '../shared/pipes/customer-pipe.module';
import { AuthorizedPresenceHistoryComponent } from './authorized-presence-history.component';
import { AuthorizedPresenceModalComponent } from './authorized-presence-modal.component';
import { AuthorizedPresenceComponent } from './authorized-presence.component';

@NgModule({
    declarations: [
        AuthorizedPresenceComponent,
        AuthorizedPresenceHistoryComponent,
        AuthorizedPresenceModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        CustomerPipeModule,
        CustomerIdentificationModule,
        SharedModule,
        SharedPipesModule,
        SpinnerModule,
        TableModule,
        CustomerNamesModule
    ],
    exports: [
        AuthorizedPresenceComponent
    ]
})

export class AuthorizedPresenceModule {
}
